import axios from 'axios';
import AuthService, { getAuthHeader } from '@commonClient2/services/auth';

const axiosService = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_API || `https://${window.location.hostname}`,
});

/**
 * @param {import('axios').AxiosResponse} response
 */
const handleSuccess = (response) => response;

/**
 * @param {import('axios').AxiosRequestConfig} request
 */
const handleRequest = (request) => {
    request.headers = getAuthHeader();
    return request;
};

/**
* @param {any} error
*/
const handleRequestError = (error) => Promise.reject(error);

/**
 * @param {any} error
 */
const handleError = (error) => {
    switch (error.response?.status) {
        case 401:
            if (error.response?.config?.baseURL === process.env.REACT_APP_BACKEND_API) {
                AuthService.logout(); // Clear user cache
            }
            break;
        case 404:
            // TODO: To be implemented ?!?
            break;
        default:
            break;
    }
    return Promise.reject(error);
};

/**
 * @param {*} error
 */
export const extractErrorMessage = (error) => error?.response?.data?.Message || error.message || error.toString();

axiosService.interceptors.request.use(handleRequest, handleRequestError);
axiosService.interceptors.response.use(handleSuccess, handleError);
export default axiosService;
